module.exports = __webpack_public_path__ + "img/24-5.2951877e.png";